export function createLabel(developerId: number) {
  return `/sale/JK/object_type=2/spec=company/${developerId}/from_developer=1/repres=0/owner=0/pod_snos=0`;
}
